import { FunctionComponent, useEffect, useState } from 'react';
import css from './GameList.module.less';
import { Pagination, Spin } from 'antd';
import GamePost from '../GamesPost/GamePost';
import { useStore } from 'effector-react';
import promotion, { getList } from '@stores/promotion';
import { pageSizeOptions } from '@constants/pagination';

const GamesList: FunctionComponent<unknown> = () => {
  const { list, preloaders, filters, pagination, setPagination } = useStore(promotion);

  const paginationChange = (current: number, pageSize?: number) => {
    setPagination({ ...pagination, current, pageSize });
    getList();
  };

  useEffect(() => {
    getList();
  }, [filters]);

  return (
    <>
      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          showQuickJumper
          showSizeChanger
          onChange={paginationChange}
          pageSizeOptions={pageSizeOptions}
        />
      </div>
      <Spin spinning={!!preloaders.getList}>
        <div>
          {list.map((promotion) => (
            <GamePost
              key={promotion.id}
              promotion={promotion}
            />
          ))}
        </div>
      </Spin>
      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          showQuickJumper
          showSizeChanger
          onChange={paginationChange}
          pageSizeOptions={pageSizeOptions}
        />
      </div>
    </>
  );
};
export default GamesList;
